<template>
  <div class="h-screen flex w-full bg-img">
    <div
      class="vx-col flex items-center justify-center flex-col sm:w-2/3 md:w-1/2 lg:w-2/5 xl:w-1/3 mx-auto text-center"
    >
      <main class="w-100">
        <h1>Bitcoin payment request</h1>

        <div>
          <vs-row class="mt-6">
            <vs-col type="flex" vs-justify="left" vs-align="center" vs-w="12">
              <vs-card>
                <div v-if="loading">Loading</div>
                <div v-else>
                  <div v-if="!missingParams" class="p-5">
                    <vs-row class="info-row">
                      <vs-col
                        vs-type=""
                        vs-justify="left"
                        vs-align="center"
                        vs-w="6"
                        style="padding: 0"
                        align="left"
                      >
                        <h5 class="pr-1">{{ invoiceNumber }}</h5>
                      </vs-col>
                      <vs-col
                        vs-type=""
                        vs-justify="left"
                        vs-align="center"
                        vs-w="6"
                        style="padding: 0"
                        align="right"
                      >
                        <h4 class="mb-1">
                          {{ formatFiatPrice(invoiceAmount) || 0 }}
                          {{ currencyFrom }}
                        </h4>
                        <h4 class="mb-1">
                          {{ formatCryptoPrice(invoiceAmountCrypto) || 0 }}
                          {{ currencyTo }}
                        </h4>
                        <span
                          >1 {{ currencyTo }} =
                          {{ formatFiatPrice(exchangeRate) || 0.0 }}
                          {{ currencyFrom }}</span
                        >
                      </vs-col>
                    </vs-row>

                    <vs-row v-if="!userInfoCollected">
                      <vs-col
                        vs-type=""
                        vs-justify="center"
                        vs-align="center"
                        vs-w="12"
                        style="padding: 0"
                        align="center"
                        class="mt-4"
                      >
                        <h5>Requested information</h5>
                        <br />

                        <div v-for="field in collectedFields" :key="field.name">
                          <vs-input
                            v-if="field.type !== 'textarea'"
                            v-model="field.value"
                            :id="`collect_${field.name}`"
                            :required="field.required"
                            :type="field.type"
                            :name="`collect_${field.name}`"
                            :placeholder="`${field.fieldName}`"
                            class="form-control text-left mb-2 input__x w-100"
                            value=""
                          >
                          </vs-input>
                          <vs-textarea
                            v-else
                            v-model="field.value"
                            :id="`collect_${field.name}`"
                            :required="field.required"
                            :type="field.type"
                            :name="`collect_${field.name}`"
                            :placeholder="`${field.fieldName}`"
                            class="form-control text-left mb-2 w-100"
                          ></vs-textarea>
                        </div>

                        <br />
                        <p
                          v-if="userInfoError"
                          class="alert alert-danger"
                          style="color: red"
                        >
                          Required information missing
                        </p>
                        <p
                          v-if="userInfoErrorEmailFormat"
                          class="alert alert-danger"
                          style="color: red"
                        >
                          Invalid email provided
                        </p>
                        <vs-button
                          id="userInfoNextBtn"
                          color="primary"
                          type="border"
                          @click="collectUserInfo"
                        >
                          {{
                            loadingPaymentForm
                              ? 'Loading...'
                              : 'Proceed with payment'
                          }}
                        </vs-button>
                      </vs-col>
                    </vs-row>

                    <!--loading payment form data-->
                    <vs-row v-if="userInfoCollected && !paymentAddress">
                      <vs-col
                        vs-type=""
                        vs-justify="center"
                        vs-align="center"
                        vs-w="12"
                        style="padding: 0"
                        align="center"
                      >
                        <br />
                        <br />
                        <br />
                        {{ loadingMessage }}
                        <br />
                        <br />
                        <img
                          src="~/../../assets/images/loading-pacman.gif"
                          alt="Loading (Pacman animation)"
                          style="width: 70px"
                        />
                        <br />
                        <br />
                        <br />
                        <br />
                      </vs-col>
                    </vs-row>
                    <!--/loading payment form data-->

                    <!--nothing paid yet-->
                    <vs-row
                      v-if="
                        userInfoCollected &&
                        paymentAddress &&
                        !formExpired &&
                        balanceTotal < 0
                      "
                    >
                      <vs-col
                        vs-type=""
                        vs-justify="center"
                        vs-align="center"
                        vs-w="12"
                        style="padding: 0"
                        align="center"
                      >
                        <div>
                          Please send
                          <strong
                            >{{
                              formatCryptoPrice(invoiceAmountCrypto)
                            }}
                            BTC</strong
                          >
                          <br />
                          to the following BTC address:
                          <br />
                          <small class="pb-2">
                            <code>
                              {{ paymentAddress || ' - loading - ' }}
                            </code>
                          </small>
                          <br />
                          or scan the following QR code:
                        </div>

                        <a
                          v-if="paymentAddress && invoiceAmountCrypto"
                          class="m-0 qrcode-wrapper"
                        >
                          <img
                            src="~/../../assets/images/logo/bitcoin.svg"
                            class="crypto-logo bitcoin-small-logo"
                            alt="Bitcoin logo"
                          />
                          <img
                            :src="`https://moneyoverip.io/api/qr/${paymentAddress}/${formatCryptoPrice(
                              invoiceAmountCrypto
                            )}`"
                            :alt="
                              'Payment address QR code for address: ' +
                              paymentAddress
                            "
                            style="width: 220px; height: 220px"
                          />
                        </a>

                        <div class="row align-content-center mb-2">
                          <div class="col-md-6 mx-auto">
                            {{
                              Math.floor(exchangeRateIntervalCountdown / 60) +
                              ':' +
                              (exchangeRateIntervalCountdown % 60)
                                .toString()
                                .padStart(2, '0')
                            }}
                            remaining
                          </div>
                        </div>

                        <div>
                          <vs-button
                            class="copy-btn small text-dark"
                            color="dark"
                            type="line"
                            @click="copyToClipboard(paymentAddress)"
                          >
                            Copy address
                          </vs-button>
                          &nbsp;
                          <vs-button
                            class="copy-btn small text-dark"
                            color="dark"
                            type="line"
                            @click="
                              copyToClipboard(
                                formatCryptoPrice(invoiceAmountCrypto)
                              )
                            "
                          >
                            Copy amount
                          </vs-button>
                        </div>
                      </vs-col>
                    </vs-row>
                    <!--/nothing paid yet-->

                    <!--paid too little-->
                    <vs-row
                      v-if="
                        userInfoCollected &&
                        paymentAddress &&
                        !formExpired &&
                        balanceTotal > 0 &&
                        balanceTotal < invoiceAmountCrypto
                      "
                    >
                      <vs-col
                        vs-type=""
                        vs-justify="center"
                        vs-align="center"
                        vs-w="12"
                        style="padding: 0"
                        align="center"
                      >
                        <div>
                          <u>
                            Only paid
                            <strong style="color: red"
                              >{{ balanceTotal }} BTC</strong
                            >
                          </u>
                          <br />
                          <br />
                          Please send
                          <strong style="color: red"
                            >{{
                              formatCryptoPrice(
                                invoiceAmountCrypto - balanceTotal
                              )
                            }}
                            BTC</strong
                          >
                          <br />
                          to the following BTC address:
                          <br />
                          <small class="pb-2">
                            <code>
                              {{ paymentAddress || ' - loading - ' }}
                            </code>
                          </small>
                          <br />
                          or scan the following QR code:
                        </div>

                        <a
                          v-if="paymentAddress && invoiceAmountCrypto"
                          class="m-0 qrcode-wrapper"
                        >
                          <img
                            src="~/../../assets/images/logo/bitcoin.svg"
                            class="crypto-logo bitcoin-small-logo"
                            alt="Bitcoin logo"
                          />
                          <img
                            :src="`https://moneyoverip.io/api/qr/${paymentAddress}/${formatCryptoPrice(
                              invoiceAmountCrypto - balanceTotal
                            )}`"
                            :alt="
                              'Payment address QR code for address: ' +
                              paymentAddress
                            "
                            style="width: 220px; height: 220px"
                          />
                        </a>

                        <div class="row align-content-center mb-2">
                          <div class="col-md-6 mx-auto">
                            {{
                              Math.floor(exchangeRateIntervalCountdown / 60) +
                              ':' +
                              (exchangeRateIntervalCountdown % 60)
                                .toString()
                                .padStart(2, '0')
                            }}
                            remaining
                          </div>
                        </div>

                        <div>
                          <vs-button
                            class="copy-btn small text-dark"
                            color="dark"
                            type="line"
                            @click="copyToClipboard(paymentAddress)"
                          >
                            Copy address
                          </vs-button>
                          &nbsp;
                          <vs-button
                            class="copy-btn small text-dark"
                            color="dark"
                            type="line"
                            @click="
                              copyToClipboard(
                                formatCryptoPrice(
                                  invoiceAmountCrypto - balanceTotal
                                )
                              )
                            "
                          >
                            Copy amount
                          </vs-button>
                        </div>
                      </vs-col>
                    </vs-row>
                    <!--/paid too little-->

                    <!--paid enough-->
                    <vs-row
                      v-if="
                        userInfoCollected &&
                        paymentAddress &&
                        !formExpired &&
                        balanceTotal > 0 &&
                        balanceTotal < invoiceAmountCrypto
                      "
                    >
                      <vs-col
                        vs-type=""
                        vs-justify="center"
                        vs-align="center"
                        vs-w="12"
                        style="padding: 0"
                        align="center"
                      >
                        <br />
                        <br />
                        <strong> Thank you for your payment! </strong>
                        <br />
                        <br />
                        The recipient will be notified.
                        <br />
                        <br />
                        <br />
                        <br />
                      </vs-col>
                    </vs-row>
                    <!--/paid enough-->

                    <!--expired, nothing paid-->
                    <vs-row
                      v-if="
                        userInfoCollected &&
                        paymentAddress &&
                        formExpired &&
                        balanceTotal <= 0
                      "
                    >
                      <vs-col
                        vs-type=""
                        vs-justify="center"
                        vs-align="center"
                        vs-w="12"
                        style="padding: 0"
                        align="center"
                      >
                        <br />
                        <br />
                        Form has expired.
                        <br />
                        <br />
                        <br />
                        Reload page to refresh.
                        <br />
                        <br />
                        <br />
                        <br />
                      </vs-col>
                    </vs-row>
                    <!--/expired, nothing paid-->

                    <!--expired, too little was paid-->
                    <vs-row
                      v-if="
                        userInfoCollected &&
                        paymentAddress &&
                        formExpired &&
                        balanceTotal > 0
                      "
                    >
                      <vs-col
                        vs-type=""
                        vs-justify="center"
                        vs-align="center"
                        vs-w="12"
                        style="padding: 0"
                        align="center"
                      >
                        <br />
                        <br />
                        Form has expired.
                        <br />
                        <u> Too little was paid. </u>
                        <br />
                        <br />
                        <br />
                        Reload page to refresh
                        <br />
                        <br />
                        <br />
                        <br />
                      </vs-col>
                    </vs-row>
                    <!--/expired, too little was paid-->
                  </div>
                  <div v-else>
                    <vs-row>
                      <vs-col
                        vs-type=""
                        vs-justify="left"
                        vs-align="center"
                        vs-w="12"
                        style="padding: 0"
                      >
                        <br />
                        <br />
                        <h5>
                          The provided URL is missing information.
                          <br />
                          We are not able to display a payment form.
                        </h5>
                        <br />
                        <br />
                      </vs-col>
                    </vs-row>
                  </div>
                  <!-- /if missing URL params -->
                </div>
              </vs-card>
            </vs-col>
          </vs-row>
        </div>
      </main>

      <br />
      <br />

      <img
        src="https://static.triple-a.io/assets/images/TripleA-main-logo-transparent.png"
        alt="TripleA logo"
        class="mx-auto mb-4 w-1/4"
      />
    </div>
  </div>
</template>

<script>
import vSelect from 'vue-select';

export default {
  components: {
    vSelect,
  },
  data() {
    return {
      // page settings
      missingParams: false,
      loading: true,
      userInfoCollected: false,
      collectedFields: [],
      loadingPaymentForm: false,
      apiDomain: process.env.API_DOMAIN,
      loadingMessages: [
        'Playing with the blocks...',
        'Untangling the chain...',
        'Stacking blocks...',
        'Scrubbing blocks...',
        'Rebooting the blockchain...',
        'Contacting the ISS...',
        'Computing 42...',
        'Eating pixels...',
      ],
      loadingMessage: '',
      interval: null,
      exchangeRateInterval: null,
      exchangeRateIntervalCountdown: 15 * 60,

      // URL parameters
      apiId: this.$route.params.apiId,
      currencyFrom: this.$route.params.currencyFrom,
      currencyTo: this.$route.params.currencyTo,
      invoiceAmount: this.$route.params.invoiceAmount,
      invoiceNumber: this.$route.params.invoiceNumber,
      // app data
      exchangeRate: 0.0,
      invoiceAmountCrypto: 0.0,
      paymentAddress: null,
      balanceTotal: -1,
      formExpired: false,
      userInfoError: false,
      userInfoErrorEmailFormat: false,
    };
  },
  beforeDestroy: function () {
    if (this.interval) clearInterval(this.interval);
  },
  mounted() {
    // Init loading message
    const i = Math.random() * this.loadingMessages.length;
    this.loadingMessage = this.loadingMessages[parseInt(i)];

    // Verify parameters
    if (
      !this.apiId ||
      !this.currencyFrom ||
      !this.currencyTo ||
      !this.invoiceAmount
    ) {
      console.warn('Missing parameters');
      this.missingParams = true;
    }

    // Init user info fields
    this.initUserInfoCollection();

    this.refreshExchangeRate();

    //this.getPaymentAddr();

    this.loading = false;
  },
  computed: {},
  watch: {},
  methods: {
    collectUserInfo() {
      // validate input values

      this.userInfoError = false;
      this.userInfoErrorEmailFormat = false;

      for (let i = 0; i < this.collectedFields.length; ++i) {
        if (
          this.collectedFields[i].required &&
          !this.collectedFields[i].value
        ) {
          console.warn(
            `Field ${this.collectedFields[i].fieldName} is required. Value needed.`
          );
          this.userInfoError = true;
          continue;
        }
        if (
          this.collectedFields[i].type === 'email' &&
          this.collectedFields[i].value.indexOf('@') < 0 &&
          this.collectedFields[i].value.length < 8
        ) {
          console.warn(
            `Invalid email for field ${this.collectedFields[i].fieldName}.`
          );
          this.userInfoErrorEmailFormat = true;
        }
      }

      if (this.userInfoError || this.userInfoErrorEmailFormat) {
        return;
      }

      // Show payment form
      this.refreshExchangeRate();
      this.getPaymentAddr();
      this.userInfoCollected = true;
    },
    initUserInfoCollection() {
      /**
       *  Parse URL params (if any)
       */
      let collectedFields = [
        {
          fieldName: 'E-mail',
          name: this.getMachineName('E-mail'),
          required: true,
          type: 'email',
          value: '',
        },
      ];
      if (this.$route.query.collect_fields) {
        // For each value to capture before showing payment form:
        // - field name,
        // - required or not
        // - type (email, text, textarea)
        // - value (optional)
        // Semi-colon ";" separated collection fields, with colon ":" separated config.

        let collect_fields = this.$route.query.collect_fields.split(';');
        for (let i = 0; i < collect_fields.length; i++) {
          let parts = collect_fields[i].split(':');
          if (parts.length >= 3) {
            let name = parts[0];
            let required = parts[1];
            let type = parts[2];
            let value = '';
            if (parts.length === 4) {
              value = parts[3];
            }

            // validate content
            if (['0', '1', 0, 1].indexOf(required) < 0) {
              return;
            }
            if (['email', 'text', 'textarea'].indexOf(type) < 0) {
              return;
            }

            let requiredBool = !!parseInt(required);

            let fieldName;
            if (!requiredBool) {
              fieldName = `(Optional) ${name}`;
            } else {
              fieldName = name;
            }

            collectedFields.push({
              fieldName: fieldName,
              name: this.getMachineName(name),
              required: requiredBool,
              type: type,
              value:
                type === 'textarea'
                  ? value.replace(/<br>/g, '\n')
                  : value.replace(/<br>/g, ''),
            });
          }
        }
      }

      if (collectedFields.length > 0) {
        this.collectedFields = collectedFields;
      } else {
        this.collectedFields = [
          {
            fieldName: 'E-mail',
            name: this.getMachineName('E-mail'),
            required: true,
            type: 'email',
            value: '',
          },
          {
            fieldName: '(Optional) Name',
            name: this.getMachineName('Name'),
            required: false,
            type: 'text',
            value: '',
          },
        ];
      }
    },
    getPaymentAddr() {
      this.setAddr(this.apiId, null, this.invoiceNumber)
        .then((result) => {
          if (!result || !result.data.addr)
            throw new Error('Problem getting balance for payment address.');

          this.exchangeRateInterval = setInterval(
            function () {
              //this.setFormExpired();
              this.exchangeRateIntervalCountdown -= 1;

              if (this.exchangeRateIntervalCountdown < 1) {
                clearInterval(this.exchangeRateInterval);
                this.formExpired = true;
              }
            }.bind(this),
            1000
          );

          this.paymentAddress = result.data.addr;
          this.echangeRate = result.data.exchange_rate;
          this.echangeRateDatetime = result.data.exchange_rate_datetime;
          this.localCurrency = result.data.localCurrency;

          this.balance(this.paymentAddress)
            .then((result) => {
              this.handleBalance(result);
            })
            .catch((error) => {
              console.warn('An error occured: ', error);
              // TODO display error message
              return error;
            });

          // Start watching the balance for this address
          this.interval = setInterval(
            function () {
              this.balance(this.paymentAddress).then((result) => {
                this.handleBalance(result);
              });
            }.bind(this),
            3000
          );

          // Send collected user info for payment address to TripleA
          for (let i = 0; i < this.collectedFields.length; ++i) {
            this.postUserInfo(
              this.collectedFields[i].name,
              this.collectedFields[i].value,
              this.paymentAddress
            );
          }

          return result;
        })
        .catch((error) => {
          console.warn('An error occured: ', error);
          // TODO display error message
          return error;
        });
    },
    handleBalance(result) {
      if (!result)
        throw new Error('Problem getting balance for payment address.');

      let balanceTotal = 0;
      if (
        result.data.balance &&
        (result.data.balance.confirmed || result.data.balance.unconfirmed)
      ) {
        if (result.data.balance.confirmed !== null) {
          balanceTotal += result.data.balance.confirmed;
        }
        if (result.data.balance.unconfirmed !== null) {
          balanceTotal += result.data.balance.unconfirmed;
        }
      } else {
        balanceTotal = -1;
      }
      this.balanceTotal = balanceTotal;

      if (this.balanceTotal >= this.invoiceAmountCrypto) {
        // No more need for balance checks
        clearInterval(this.interval);
      } else if (balanceTotal >= 0) {
        //
      }

      return result;
    },
    refreshExchangeRate() {
      this.exchange(this.currencyTo, this.currencyFrom, 1.0).then(
        (data) => {
          console.log('exchange rate : ', data);
          if (data.data.amount) {
            this.exchangeRate = data.data.amount;
            this.invoiceAmountCrypto = this.invoiceAmount / this.exchangeRate;
          } else this.exchangeRate = 0;

          return data;
        },
        (error) => {
          console.warn('Error', error);
          this.exchangeRate = 0;

          return error;
        }
      );
    },
  },
};
</script>

<style scoped>
.info-row {
  padding-bottom: 20px;
  border-bottom: 1px solid #eee;
  margin-bottom: 20px;
}

.qrcode-wrapper {
  width: 220px;
  height: 220px;
  margin: 0 auto;
  display: block;
  position: relative;
}

.qrcode-image {
  display: block;
  width: 220px;
  height: 220px;
  margin: 0 auto;
  position: relative;
  background: white url(~/../../assets/images/loading.gif) no-repeat scroll
    center;
  background-size: 40px 40px;
}

img.crypto-logo {
  width: 48px;
  height: 48px;
  position: absolute;
  display: block;
  z-index: 2;
  margin: calc(210px / 2) 0 0 calc(210px / 2);
  transform: translate3d(-50%, -50%, 0px);
}
</style>
